module.exports = __webpack_public_path__ + "static/media/dc_brainslug.f8b8235e.jpg";